// Maps ICAO 3-letter country codes (used in passport MRZ) to ISO 2-letter codes
// Only includes countries present in the COUNTRIES array in questions.ts
export const ICAO_TO_ISO2: Record<string, string> = {
  AFG: 'AF',
  ALB: 'AL',
  DZA: 'DZ',
  ARG: 'AR',
  AUS: 'AU',
  AUT: 'AT',
  BGD: 'BD',
  BEL: 'BE',
  BRA: 'BR',
  CAN: 'CA',
  CHN: 'CN',
  COL: 'CO',
  EGY: 'EG',
  FRA: 'FR',
  D: 'DE',    // Germany uses 'D' in MRZ
  DEU: 'DE',
  GHA: 'GH',
  IND: 'IN',
  IDN: 'ID',
  IRN: 'IR',
  IRQ: 'IQ',
  IRL: 'IE',
  ISR: 'IL',
  ITA: 'IT',
  JPN: 'JP',
  KEN: 'KE',
  KOR: 'KR',
  MYS: 'MY',
  MEX: 'MX',
  MAR: 'MA',
  NLD: 'NL',
  NZL: 'NZ',
  NGA: 'NG',
  PAK: 'PK',
  PER: 'PE',
  PHL: 'PH',
  POL: 'PL',
  PRT: 'PT',
  RUS: 'RU',
  SAU: 'SA',
  SGP: 'SG',
  ZAF: 'ZA',
  ESP: 'ES',
  LKA: 'LK',
  SWE: 'SE',
  CHE: 'CH',
  SYR: 'SY',
  TWN: 'TW',
  THA: 'TH',
  TUR: 'TR',
  UKR: 'UA',
  ARE: 'AE',
  GBR: 'GB',
  USA: 'US',
  VEN: 'VE',
  VNM: 'VN',
  HTI: 'HT',
  SEN: 'SN',
  CIV: 'CI',
  CMR: 'CM',
  COD: 'CD',
  TUN: 'TN',
  LBN: 'LB',
  ROU: 'RO',
  HUN: 'HU',
  CZE: 'CZ',
  GRC: 'GR',
};
